import type { MarginPresetKey, PaperPreset } from "./types";

export const PAPER_PRESETS: Record<Exclude<PaperPreset, "CUSTOM">, [number, number]> = {
  A0: [841, 1189],
  A1: [594, 841],
  A2: [420, 594],
  A3: [297, 420],
  A4: [210, 297],
  A5: [148, 210],
  A6: [105, 148],
  LETTER: [215.9, 279.4],
  LEGAL: [215.9, 355.6],
};

export interface MarginPresetValue {
  t: number; r: number; b: number; l: number;
  linked: boolean;
}

export const MARGIN_PRESETS: Record<Exclude<MarginPresetKey, "custom">, MarginPresetValue> = {
  tight:     { t: 3,    r: 3,    b: 3,    l: 3,    linked: true },
  standard:  { t: 10,   r: 10,   b: 15,   l: 10,   linked: false },
  uniform10: { t: 10,   r: 10,   b: 10,   l: 10,   linked: true },
  uniform15: { t: 15,   r: 15,   b: 15,   l: 15,   linked: true },
  safe:      { t: 20,   r: 20,   b: 20,   l: 20,   linked: true },
  us:        { t: 6.35, r: 6.35, b: 6.35, l: 6.35, linked: true },
};
